



































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Account, Building, Company, Provider } from '@/models'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { AccountUtils } from '@/utils/account-utils'
import { CV_VALUE_COUNTRY, CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT } from '@/utils/constants'
import LdapImportModal from '@/components/modals/LdapImportModal.vue'
import AccountMetadataDetail from '@/components/AccountMetadataDetail.vue'
import ApiClient from '@/services/api-client'

@Component({
  components: {
    LdapImportModal,
    AccountMetadataDetail
  }
})
export default class AccountHeader extends Vue {
  @Prop({ required: true }) account!: Account

  private companies: Company[] = []
  private buildings: Building[] = []
  private providers: Provider[] = []

  async created() {
    await this.loadCompanies()
    await this.loadBuildings()
    await this.loadProviders()
  }

  async loadCompanies() {
    try {
      this.companies = await ApiClient.getCompanies()
    } catch (error) {
      console.error('Error loading companies:', error)
    }
  }

  async loadBuildings() {
    try {
      this.buildings = await ApiClient.getBuildings()
    } catch (error) {
      console.error('Error loading buildings:', error)
    }
  }

  async loadProviders() {
    try {
      this.providers = await ApiClient.getProviders()
    } catch (error) {
      console.error('Error loading providers:', error)
    }
  }

  getCountryName(countryCode: string | undefined): string {
    if (!countryCode) return '-'
    return CvValueUtils.getCvValueName(countryCode, CV_VALUE_COUNTRY) || '-'
  }

  getBusinessUnitName(businessUnitCode: string | undefined): string {
    if (!businessUnitCode) return '-'
    return CvValueUtils.getCvValueName(businessUnitCode, CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT) || '-'
  }

  getProfileLabel(profile: string | undefined): string {
    return this.$t(AccountUtils.getProfileTranslationKey(profile)).toString()
  }

  getCompanyName(companyId: string | undefined): string {
    if (!companyId) return '-'
    const company = this.companies.find(c => c.id === companyId)
    return company ? company.name : '-'
  }

  getBuildingName(buildingId: number | undefined): string {
    if (!buildingId) return '-'
    const building = this.buildings.find(b => b.id === buildingId)
    return building ? building.name : '-'
  }

  getProviderName(providerId: number | undefined): string {
    if (!providerId) return '-'
    const provider = this.providers.find(p => p.id === providerId)
    return provider ? provider.name : '-'
  }

  openLdapImportModal() {
    const modal = this.$refs.ldapImportModal as any
    if (modal) {
      modal.show(this.account.ldapImport, this.account.accountId)
    }
  }
}
